"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stocksStore = void 0;
const api_1 = require("client/api");
const mobx_1 = require("mobx");
class StocksStore {
    constructor() {
        this.cycleCounts = {
            value: [],
            loading: false
        };
        this.submitInitial = async (site, cycleCountInventories) => {
            const response = await api_1.SiteEndpoint.savecyclecountinitial.apiCall(null, {
                site,
                cycleCountInventories
            });
            if (api_1.isError(response)) {
                alert("error in saving initial cycle count");
            }
            else {
                this.cycleCountSavedInitial = response.newCycleCount;
            }
        };
        this.submit = async (site, cycleCountHeader, cycleCountInventories) => {
            console.log("inside stock store cyclecountheader is", cycleCountHeader);
            console.log("inside stock store cyclecountinventories is", cycleCountInventories);
            const response = await api_1.SiteEndpoint.savecyclecount.apiCall(null, {
                site,
                cycleCountHeader,
                cycleCountInventories
            });
            if (api_1.isError(response)) {
                alert("error in saving cycle count");
            }
            else {
                console.log("response is ", response);
            }
        };
        this.updateInventoryQuantityAndLot = async (site, action, exceptionReason, inventory, lots, cycleCountAndActualQuantity, cycleCountHeader) => {
            const response = await api_1.SiteEndpoint.updateinventoryquantityandlot.apiCall(null, {
                site,
                action,
                exceptionReason,
                inventory,
                lots,
                cycleCountAndActualQuantity,
                cycleCountHeader
            });
            if (api_1.isError(response)) {
                alert("error in updating inventory quantity and lot");
                console.error("Error in updating inventorysite qty and lot qty", response.code);
            }
            else {
                // else
            }
        };
        this.readLatestCycleCount = async (siteId) => {
            const response = await api_1.SiteEndpoint.readlatestcyclecount.apiCall({
                query: { siteId }
            });
            if (api_1.isError(response)) {
                alert("Error in reading latest cycle count");
                console.error("Error in reading latest cycle count", response.code);
            }
            else {
                this.latestCycleCount = response.latestCycleCount;
            }
        };
        this.loadCycleCounts = async (query) => {
            this.cycleCounts = Object.assign(Object.assign({}, this.cycleCounts), { loading: true });
            const response = await api_1.SiteEndpoint.listcyclecounts.apiCall({
                query
            });
            if (api_1.isError(response)) {
                console.log("error in loading cycle counts", response);
                this.cycleCounts = Object.assign({}, this.cycleCounts);
            }
            else {
                this.cycleCounts = Object.assign(Object.assign({}, this.cycleCounts), { value: response.cycleCounts });
            }
        };
    }
}
__decorate([
    mobx_1.observable
], StocksStore.prototype, "cycleCountSavedInitial", void 0);
__decorate([
    mobx_1.observable
], StocksStore.prototype, "latestCycleCount", void 0);
__decorate([
    mobx_1.observable
], StocksStore.prototype, "cycleCounts", void 0);
__decorate([
    mobx_1.action
], StocksStore.prototype, "submitInitial", void 0);
__decorate([
    mobx_1.action
], StocksStore.prototype, "submit", void 0);
__decorate([
    mobx_1.action
], StocksStore.prototype, "updateInventoryQuantityAndLot", void 0);
__decorate([
    mobx_1.action
], StocksStore.prototype, "readLatestCycleCount", void 0);
__decorate([
    mobx_1.action
], StocksStore.prototype, "loadCycleCounts", void 0);
exports.stocksStore = new StocksStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/stocks/store.ts
// module id = 2994
// module chunks = 0